export default [
  {
    icon: 'TimelineIcon',
    subTitle: 'Masukkan BIGPAY5 dalam kotak kod promo dan tekan Carian',
    title: '1'
  },
  {
    icon: 'PeopleIcon',
    subTitle: 'Pilih penerbangan anda dan masukkan maklumat peribadi anda',
    title: '2'
  },
  {
    icon: 'ReceiptIcon',
    subTitle: 'Sempurnakan bayaran dengan kad BigPay dan tunggu pengesahan tempahan.',
    title: '3'
  }
]